module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat2@2x-c29c6c8bbe26290802bbf6570e24f684.jpg";